module.exports = __webpack_public_path__ + "static/media/game.474db2a2.png";